const _excluded = ["onChange", "onFocus", "onBlur", "value", "error", "size", "readOnly", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { useFormCommonProps } from "../../context/form-common";
import { RangeInput } from "./base";
import '@isyc-react/design/main';
import "./input-range.style.scss";
export const InputRange = props => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onFocus,
      // TODO necessary ?
      onBlur,
      // TODO necessary ?
      value,
      error,
      size,
      // TODO any changes on size??
      readOnly,
      disabled
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('input-range-container', {
      'input-range-error': error
    })
  }, /*#__PURE__*/React.createElement(RangeInput, _extends({
    onChange: v => {
      onChange && onChange(v);
    }
    // onFocus={() => onFocus && onFocus()}
    // onBlur={() => onBlur && onBlur()}
    ,
    value: value !== null && value !== void 0 ? value : 0,
    disabled: disabled || readOnly
  }, rest)));
};